<template>
  <header>
    <ui-skip-to-main-link />
    <div class="flex h-header items-center justify-between bg-primary-800 pr-4 sm:px-4">
      <nav class="md:hidden">
        <ui-header-hamburger-menu-button v-model="menuOpen" aria-controls="hamburger-menu" />
        <ui-header-hamburger-menu id="hamburger-menu" v-model="menuOpen" />
      </nav>
      <div class="flex items-center gap-10 sm:ml-4">
        <a class="flex h-full" href="/">
          <mb-ready-logo class="flex h-5 sm:h-8" :alt="t('130Cxu7VAOieOSZN_No6j')" aria-hidden="true" />
          <span class="sr-only">{{ t('xmOWwAX5_1vG8RqC5T577') }}</span>
        </a>
        <ui-header-nav-bar class="hidden md:flex" />
      </div>

      <ui-emergency-button />
    </div>
  </header>
</template>

<script setup lang="ts">
import MbReadyLogo from '@/common/assets/logos/mb-ready-logo.svg?component';

import { useEventBus } from '@/composables';
import { onUnmounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const menuOpen = ref(false);

const { t } = useI18n();
const eventBus = useEventBus();

watch(menuOpen, () => {
  eventBus.emit('action-with-parameters', {
    action: 'mobile-nav-menu-state',
    params: { value: menuOpen.value },
  });
});

onUnmounted(() => {
  eventBus.offActionWithParameters('mobile-nav-menu-state');
});
</script>
